import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, LogOut } from 'lucide-react';
import { useLab } from '../LabContext';
import { LabBackground, NoIndex, NimnyArt, Card } from '../LabUI';

// Anita does not yet have her own learning path. Show a calm placeholder
// so the account works and feels real, without exposing Max's lessons.
const AnitaHome = () => {
  const { user, language, signOut, toggleLanguage } = useLab();

  return (
    <div className="min-h-screen relative text-[#f5ebe0]">
      <LabBackground />
      <NoIndex />

      <div className="max-w-md mx-auto px-5 pt-5 pb-12">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <NimnyArt size="sm" />
            <span className="text-xl text-[#f5ebe0]/90 lab-brand-mark">Nimny Lab</span>
          </div>
          <button
            type="button"
            onClick={toggleLanguage}
            className="px-3 py-1.5 rounded-full border border-amber-300/20 text-amber-200/80 text-sm font-sans hover:bg-amber-300/5"
            data-testid="anita-home-lang-toggle"
            aria-label="Toggle language"
          >
            {language === 'ru' ? 'EN' : 'RU'}
          </button>
        </div>

        <div className="mt-10 text-center">
          <h1
            className="text-3xl text-[#f3d9a4]"
            style={{ fontFamily: 'var(--font-heading)' }}
            data-testid="anita-home-title"
          >
            {language === 'ru' ? `Привет, ${user?.name || 'Анита'}!` : `Hello, ${user?.name || 'Anita'}!`}
          </h1>
        </div>

        <Card className="mt-8 p-6 text-center">
          <NimnyArt size="md" />
          <p
            className="mt-4 text-amber-100/80 font-serif leading-relaxed"
            data-testid="anita-home-placeholder"
          >
            {language === 'ru'
              ? 'Путь Аниты скоро появится.'
              : "Anita's path is coming soon."}
          </p>
          <p className="mt-2 text-amber-200/60 text-sm font-sans">
            {language === 'ru'
              ? 'Мы готовим уроки специально для тебя.'
              : 'We are preparing lessons just for you.'}
          </p>
        </Card>

        <div className="mt-8 space-y-3">
          <Link
            to="/lab"
            className="flex items-center justify-center gap-2 w-full py-3 rounded-2xl border border-amber-300/20 text-amber-200/80 font-sans hover:bg-amber-300/5"
            data-testid="anita-home-back"
          >
            {language === 'ru' ? 'На главную' : 'Home'}
            <ChevronRight className="w-4 h-4" />
          </Link>
          <button
            type="button"
            onClick={async () => { await signOut(); }}
            className="flex items-center justify-center gap-2 w-full py-3 rounded-2xl border border-amber-300/15 text-amber-200/60 font-sans hover:bg-amber-300/5"
            data-testid="anita-home-logout"
          >
            <LogOut className="w-4 h-4" />
            {language === 'ru' ? 'Выйти' : 'Sign out'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnitaHome;
